<div class="unauthorized-container">
	<div class="unauthorized-content">
		<h1>{{ title }}</h1>
		<p>{{ message }}</p>
		<button type="button" mat-raised-button color="primary" (click)="returnToLogin()">Return to Login</button>
	</div>
</div>